import { COLORS, borderRadiusSm, marginSm, paddingMd } from 'assets/styled';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  padding: ${paddingMd} 0;
  border-radius: ${borderRadiusSm};
  background-color: ${COLORS.WHITE};
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 10rem;
  align-items: center;
  margin-bottom: 25rem;
`;

export const Title = styled.label`
  font-weight: 300;
  font-size: 16rem;
  line-height: 16rem;
  text-transform: uppercase;
  color: ${COLORS.BLACK};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: ${marginSm};
`;

export const CompanyLogoImg = styled.img`
  border-radius: ${borderRadiusSm};
  height: fit-content;
  max-width: 240rem;
`;

export const LoaderAndImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.GRAY_300};
  border-radius: 20rem;
  padding: 15rem;
`;

export const RemoveLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${borderRadiusSm};
  padding: 15rem 15rem 0;
  align-self: flex-end;
`;

export const RemoveLogoButton = styled.span`
  display: flex;
  align-items: center;
  font-size: 14rem;
  gap: 5rem;
  justify-content: center;
  cursor: pointer;
  color: ${COLORS.RED_100};
  line-height: 1;

  &:hover {
    text-decoration: underline;
    transition: 0.3s ease;
  }
`;
